export default function PageContainer(props) {
    const style = { padding: 16 }
    return (
        <div style={style}>
            {props.children}
        </div>
    )
}
